import apiService from '@/services/apiService';

const state = {
  amenities: [],
  loading: false,
  error: null
};

const mutations = {
  SET_AMENITIES(state, amenities) {
    console.log('🔄 STORE MUTATION: Setting amenities:', {
      count: amenities.length,
      sample: amenities.slice(0, 3),
      allIds: amenities.map(a => a.id)
    });
    state.amenities = amenities;
  },
  SET_LOADING(state, loading) {
    console.log('🔄 STORE MUTATION: Setting loading state:', loading);
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    console.log('❌ STORE MUTATION: Setting error:', error);
    state.error = error;
  }
};

const actions = {
  async fetchAmenities({ commit, state }) {
    console.log('🚀 STORE ACTION: Starting fetchAmenities...');
    
    // Don't fetch if already loading or have data
    if (state.loading) {
      console.log('⏸️ Already loading amenities, skipping...');
      return;
    }
    
    if (state.amenities.length > 0) {
      console.log('✅ Amenities already cached:', state.amenities.length);
      return state.amenities;
    }

    commit('SET_LOADING', true);
    commit('SET_ERROR', null);
    
    try {
      console.log('📡 Making API call to fetch amenities...');
      const response = await apiService.amenities.getAll();
      
      console.log('📡 Raw API response:', {
        status: response.status,
        data: response.data,
        dataStructure: Object.keys(response.data)
      });
      
      // Handle different response structures
      let amenities;
      if (response.data.data) {
        amenities = response.data.data;
        console.log('✅ Using response.data.data structure');
      } else if (Array.isArray(response.data)) {
        amenities = response.data;
        console.log('✅ Using direct response.data array');
      } else {
        throw new Error('Unexpected response structure');
      }
      
      console.log('✅ Processed amenities:', {
        count: amenities.length,
        firstThree: amenities.slice(0, 3),
        structure: amenities[0] ? Object.keys(amenities[0]) : 'No amenities'
      });
      
      commit('SET_AMENITIES', amenities);
      return amenities;
    } catch (error) {
      console.error('❌ Error fetching amenities:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });
      commit('SET_ERROR', error.message);
      throw error;
    } finally {
      commit('SET_LOADING', false);
    }
  }
};

const getters = {
  getAllAmenities: (state) => {
    console.log('🔍 GETTER: getAllAmenities called, returning:', state.amenities.length, 'amenities');
    return state.amenities;
  },
  isLoading: (state) => {
    console.log('🔍 GETTER: isLoading called, returning:', state.loading);
    return state.loading;
  },
  getError: (state) => state.error,
  getAmenityById: (state) => (id) => {
    const amenity = state.amenities.find(a => a.id === id);
    console.log('🔍 GETTER: getAmenityById called for ID:', id, 'found:', amenity);
    return amenity;
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};